import {
  SyntheticEvent,
  useContext,
  useMemo,
  useState,
} from "react";
import { useMutation } from "react-query";
import {  saveTimeSlot } from "./services";
import { MasterTableDataType, TimeSlotType } from "./types";
import { useLocation } from "react-router-dom";
import { DoctorMasterDataContext } from "./context/DoctorMasterDataProvider";
import {
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  IconButton,
  ListItem,
  ListItemIcon,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
type DayType = { value: number; label: string };
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import dayjs from "dayjs";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import usePopup from "../../../hooks/usePopup";
export const timeSlotFormat = "YYYY-MM-DD HH:mm:ss";
function TimeSlotes() {
  const { timeSlots, setTimeSlots, } = useContext(DoctorMasterDataContext);
  const {showSnackbar} = usePopup()
  const [selectedDay, setSelectedDay] = useState<DayType[]>([]);
  const [isEditMode,setIsEditMode] = useState<boolean>(false);
  const [selectedTime, setSelectedTime] = useState<{
    from: string;
    to: string;
  }>({
    from: `${dayjs().format("YYYY-MM-DD")} 09:00:00`,
    to: `${dayjs().format("YYYY-MM-DD")} 17:00:00`,
  });

  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };

const {mutate:saveSlot,isLoading:saveLoading} = useMutation(saveTimeSlot,{
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        setIsEditMode(false)
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.errorMessage ||
          e?.response?.data?.responseMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
})

  const handleDelete = (id: number) => {
    const update = { ...timeSlots };
    if (update[id]) {
      console.log(update[id],"efiwefeiufuefuof")
      delete update[id];
    }
    setTimeSlots(update);
    setIsEditMode(true);
  };

  const handleDaySelect = (_: SyntheticEvent, day: DayType[] | null) => {
    let selected: DayType[] = [];
    if (day) {
      if (day.find((i) => i.value == -1)) {
        selected = selectedDay.length == 7 ? [] : daysList;
      } else {
        selected = day;
      }
    } else {
      selected = [];
    }
    setSelectedDay(selected);
  };

  const handleFromOnChange = (value: any, _: any) => {
    const from = dayjs(value).format(timeSlotFormat);
    setSelectedTime((prev) => ({ ...prev, from }));
  };

  const handleToOnChange = (value: any, _: any) => {
    const to = dayjs(value).format(timeSlotFormat);
    setSelectedTime((prev) => ({ ...prev, to }));
  };

  const handleAdd = () => {
    const update = { ...timeSlots };
    selectedDay.forEach((day) => {
      update[day.value] = {
        dayId: day.value,
        effectiveFrom: Boolean(timeSlots[day.value]?.effectiveFrom)
          ? timeSlots[day.value].effectiveFrom
          : moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        startTime: dayjs(selectedTime.from, timeSlotFormat).format("HH:mm:ss"),
        endTime: dayjs(selectedTime.to, timeSlotFormat).format("HH:mm:ss"),
        id: data?.id || 0,
      };
    });
    setTimeSlots(update);
  };

  const slotList: TimeSlotType[] = useMemo(() => {
    if (Object.entries(timeSlots).length){
      return Object.entries(timeSlots)
        .map((item) => item[1])
        .sort((day1, day2) => day1.dayId - day2.dayId);
    } else {
      return [];
    }
  }, [timeSlots]);

    const handleSave = () => {
      saveSlot({
          canAllocateForMultiplePatient:true,
          day:slotList,
          doctorId:data?.id || null,
          isAllDaySame:false,
          status:1
      })
  };

  return (
    <div className="">
      <div className="py-3 px-2">
        <div className="px-2 py-4 grid grid-cols-4 gap-3 border rounded">
          <Autocomplete
            multiple
            id="tags-standard"
            value={selectedDay}
            options={[{ value: -1, label: "All" }, ...daysList]}
            getOptionLabel={(option) => option.label}
            onChange={handleDaySelect}
            renderInput={(params) => (
              <TextField {...params} label="Select day" placeholder="Day" />
            )}
            renderOption={(props, option, { selected }) => (
              <ListItem {...props}>
                <ListItemIcon>
                  {option.value != -1 && (
                    <Checkbox size="small" checked={selected} />
                  )}
                </ListItemIcon>
                {option.label}
              </ListItem>
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  size="small"
                  label={option.label}
                  {...getTagProps({ index })}
                />
              ))
            }
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              minutesStep={1}
              defaultValue={
                selectedTime.from
                  ? dayjs(
                      dayjs(selectedTime.from, timeSlotFormat),
                      timeSlotFormat
                    )
                  : dayjs()
              }
              onChange={handleFromOnChange}
              format="hh:mm A"
              label="Enter start time"
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              minutesStep={1}
              defaultValue={
                selectedTime.to
                  ? dayjs(
                      dayjs(selectedTime.to, timeSlotFormat),
                      timeSlotFormat
                    )
                  : dayjs()
              }
              onChange={handleToOnChange}
              format="hh:mm A"
              label="Enter end time"
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
            />
          </LocalizationProvider>

          <div className="flex gap-3 justify-end items-center">
            <Button
              disabled={slotList.length == 7}
              onClick={handleAdd}
              endIcon={<AddIcon />}
            >
              add
            </Button>
          </div>
        </div>
      </div>
      <div className="flex justify-end items-center px-4">
        <Button
          disabled={ isEditMode ? false : (!Boolean(slotList.length) || saveLoading)}
          onClick={handleSave}
          color="success"
          endIcon={saveLoading ? <CircularProgress size={18} color="success" /> : <SaveIcon />}
        >
          save
        </Button>
      </div>
      <div>
        <TableContainer className="max-h-[70dvh] overflow-y-auto p-2">
          <div className="border">
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {headings.map((title) => (
                    <TableCell>{title}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <CustomTableBody
                alert={"No data"}
                dataLoading={false}
                isData={Boolean(slotList?.length)}
                totalSpan={{ row: 5, col: headings.length }}
              >
                {slotList.map((tieSlot, index) => (
                  <TableRow>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell width={500}>
                      {days[tieSlot.dayId as keyof typeof days]}
                    </TableCell>
                    <TableCell>
                      {moment
                        .utc(tieSlot.effectiveFrom)
                        .format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell>
                      {moment(tieSlot.startTime, "HH:mm").format("hh:mm A")}
                    </TableCell>
                    <TableCell>
                      {moment(tieSlot.endTime, "HH:mm").format("hh:mm A")}
                    </TableCell>
                    <TableCell width={200}>
                      <div className="flex gap-2">
                        <IconButton
                          color={"error"}
                          onClick={() => {
                            handleDelete(tieSlot.dayId);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </CustomTableBody>
            </Table>
          </div>
        </TableContainer>
      </div>
    </div>
  );
}

export default TimeSlotes;

const headings = [
  "Sl no",
  "Day",
  "Effective from",
  "Start time",
  "End time",
  "Action",
];

const daysList = [
  {
    value: 0,
    label: "Sunday",
  },
  {
    value: 1,
    label: "Monday",
  },
  {
    value: 2,
    label: "Tuesday",
  },
  {
    value: 3,
    label: "Wednesday",
  },
  {
    value: 4,
    label: "Thursday",
  },
  {
    value: 5,
    label: "Friday",
  },
  {
    value: 6,
    label: "Saturday",
  },
];

const days = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};
